/**
 * CZNA-1421 — remembers, per user, which siglas the review queue's "Sigla" facet has
 * selected, so a supervisor who reviews a few libraries finds them chosen again after a
 * reload or a new login.
 *
 * <p>localStorage for the same reason as CZNA-554's "seen" marker: mod-czna-users has no
 * per-user preference store. The key carries the user id, so a colleague signing in on the
 * same browser does not inherit the selection. It does not follow the user to another
 * machine; there the queue just opens unfiltered, which hides nothing.
 *
 * <p>Reads are defensive: anything that is not the stored shape degrades to "nothing
 * selected" rather than filtering the queue by a value no checkbox can clear.
 */
export var EMPTY_SIGLA_SELECTION = { siglas: [], withoutSigla: false };
var STORAGE_KEY_PREFIX = 'czna:review-queue:siglas:';
export var siglaSelectionKey = function (userId) { return "".concat(STORAGE_KEY_PREFIX).concat(userId); };
var storage = function () {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            return window.localStorage;
        }
    }
    catch (_a) {
        // SecurityError — fall through.
    }
    return null;
};
export var isSiglaSelectionEmpty = function (selection) {
    return selection.siglas.length === 0 && !selection.withoutSigla;
};
/** The remembered selection of this user, or nothing selected. */
export var readSiglaSelection = function (userId) {
    var store = storage();
    if (!userId || !store)
        return EMPTY_SIGLA_SELECTION;
    try {
        var raw = store.getItem(siglaSelectionKey(userId));
        if (!raw)
            return EMPTY_SIGLA_SELECTION;
        var parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null)
            return EMPTY_SIGLA_SELECTION;
        var _a = parsed, siglas = _a.siglas, withoutSigla = _a.withoutSigla;
        if (!Array.isArray(siglas) || !siglas.every(function (value) { return typeof value === 'string'; })) {
            return EMPTY_SIGLA_SELECTION;
        }
        return {
            siglas: siglas.filter(function (value, index, all) { return all.indexOf(value) === index; }),
            withoutSigla: withoutSigla === true,
        };
    }
    catch (_b) {
        return EMPTY_SIGLA_SELECTION;
    }
};
/** Remembers the selection; an empty one is a removal, so clearing really forgets. */
export var writeSiglaSelection = function (userId, selection) {
    var store = storage();
    if (!userId || !store)
        return;
    try {
        if (isSiglaSelectionEmpty(selection)) {
            store.removeItem(siglaSelectionKey(userId));
        }
        else {
            store.setItem(siglaSelectionKey(userId), JSON.stringify(selection));
        }
    }
    catch (_a) {
        // QuotaExceeded / SecurityError — the selection just will not be remembered.
    }
};
